import { Divider } from "components/design/Divider";
import { Button } from "components/DesignSystem/Button/Button";
import { Tag } from "components/DesignSystem/Tag/Tag";
import { ArrowLeft } from "components/icons/ArrowLeft";
import { Create } from "components/icons/Create";
import { ListIcon } from "components/icons/ListIcon";
import { TimePastIcon } from "components/icons/TimePastIcon";
import InkleAiIcon from "../../static/images/InkleAIIcon.png";
import ToolTip from "components/design/toolTip";
import classNames from "classnames";

export const InkleAIChatSliderHeader = ({
  entityName,
}: {
  entityName: string;
}) => {
  return (
    <div className="t-flex t-items-start t-gap-2 t-p-3">
      <div className="t-flex t-items-center">
        <img className="t-w-10 t-h-10" src={InkleAiIcon} alt="Inkle AI Icon" />
      </div>

      <div className="t-flex t-flex-col t-gap-0.5 t-flex-1 t-pl-3">
        <div className="t-flex t-items-center t-gap-2">
          <span className=" t-text-subtext t-font-medium t-text-text-100">
            Inkle AI Agent
          </span>
          <Tag rounded icon={false} tagType="blue" size="small">
            Beta
          </Tag>
        </div>

        <div className=" t-text-subtext-sm t-text-text-30">
          Your AI assistant for tax & books
        </div>
      </div>
    </div>
  );
};

export const InkleAIChatSliderLeftBar = ({
  onListClick,
  onCreateClick,
  onHistoryClick,
  activeView,
  isHistoryThread,
}: {
  onListClick: () => void;
  onCreateClick: () => void;
  onHistoryClick: () => void;
  activeView?: "none" | "list" | "history";
  isHistoryThread?: boolean;
}) => {
  const isCreateActive = activeView === "none" && !isHistoryThread;
  const isHistoryActive =
    activeView === "history" || (activeView === "none" && isHistoryThread);
  const isListActive = activeView === "list";

  const activeColor = "#706A85";
  const defaultColor = "#706A85";

  return (
    <div className="t-flex t-flex-col t-gap-3 t-items-center t-mt-1">
      <ToolTip text="New Chat" side="left">
        <Button
          customType="ghost_icon"
          onClick={onCreateClick}
          id="inkle-ai-create-chat"
        >
          <Create color={isCreateActive ? activeColor : defaultColor} />
        </Button>
      </ToolTip>

      <div className="t-w-8">
        <Divider />
      </div>

      <ToolTip text="Chat History" side="left">
        <Button
          customType="ghost_icon"
          onClick={onHistoryClick}
          id="inkle-ai-history"
          className={classNames({
            "!t-bg-purple-10 hover:!t-bg-purple-20": isHistoryActive,
          })}
        >
          <TimePastIcon color={isHistoryActive ? activeColor : defaultColor} />
        </Button>
      </ToolTip>

      <ToolTip text="Action Library" side="left">
        <Button
          customType="ghost_icon"
          onClick={onListClick}
          id="inkle-ai-action-library"
          className={classNames({
            "!t-bg-purple-10 hover:!t-bg-purple-20": isListActive,
          })}
        >
          <ListIcon className="t-text-neutral" />
        </Button>
      </ToolTip>
    </div>
  );
};

export type HistoryChatHeaderProps = {
  onBackToHistory: () => void;
  conversationTitle: string;
};

export const HistoryChatHeader = ({
  onBackToHistory,
  conversationTitle,
}: HistoryChatHeaderProps) => {
  return (
    <div className="t-flex t-items-center t-m-3">
      <Button onClick={onBackToHistory} customType="ghost_icon" size="xsmall">
        <ArrowLeft size="15" />
      </Button>
      <div className="t-font-medium t-text-text-60">{conversationTitle}</div>
    </div>
  );
};

export const EntityBanner = ({ entityName }: { entityName?: string }) => {
  return (
    <div className="t-w-full t-h-8 t-flex t-bg-blue-0 t-justify-center t-rounded-tl-xl t-items-center">
      <div className=" t-text-blue-80 t-italic t-text-subtext-sm t-font-light">
        This chat thread is associated with entity{" "}
        <span className="t-font-semibold">{entityName}</span>
      </div>
    </div>
  );
};
